/**
 * Application slugs used across the app (API, guards, AppSelector, etc.).
 * Must match backend application slugs.
 */
export const APPLICATION_SLUGS = {
    EZTURN: 'ezturn',
    EZFOLIO: 'ezfolio',
    EZMANAGE: 'ezmanage',
    GARD: 'gard',
    EZTENANT: 'eztenant',
    EZVENDOR: 'ezvendor',
} as const

export type ApplicationSlug = typeof APPLICATION_SLUGS[keyof typeof APPLICATION_SLUGS]

/** Display names for each application (e.g. for access-denied page). */
export const APPLICATION_DISPLAY_NAMES: Record<ApplicationSlug, string> = {
    [APPLICATION_SLUGS.EZTURN]: 'EZTurn',
    [APPLICATION_SLUGS.EZFOLIO]: 'EZFolio',
    [APPLICATION_SLUGS.EZMANAGE]: 'EZManage',
    [APPLICATION_SLUGS.GARD]: 'Gard',
    [APPLICATION_SLUGS.EZTENANT]: 'EZTenant',
    [APPLICATION_SLUGS.EZVENDOR]: 'EZVendor',
}

/** Slugs of applications that must always be granted to a company and cannot be unselected in the modal. */
export const REQUIRED_APPLICATION_SLUGS: ApplicationSlug[] = [
    APPLICATION_SLUGS.EZFOLIO,
]
